import { padStart, get } from 'lodash-es';

/**
 * 返回属性默认值
 * @param config 属性配置
 * @param result 当前同级节点数据
 * @returns
 */
export const getItemDefault = (config: DpMapItem, result: any) => {
  const { defaultValue, type = 'number', bytes = 1, extension } = config;
  if (typeof defaultValue !== 'undefined') {
    return defaultValue;
  }
  const length = getBytes(config, result) * 2;
  switch (type) {
    case 'number':
    case 'signedNumber':
    case 'numberBySeparate':
      if (extension) {
        const { min } = extension;
        return typeof min === 'undefined' ? 0 : min;
      }
      return 0;
    case 'string':
      return padStart('00', length, '0');
    case 'boolean':
      return false;
    case 'enum':
      if (extension) {
        const { range } = extension;
        return Array.isArray(range) && range.length ? range[0] : 0;
      }
      return 0;
    case 'week':
      return [0, 0, 0, 0, 0, 0, 0];
    case 'bit':
      return [...new Array(length).keys()].map(() => 0);
    case 'child':
      return {};
    default:
      return;
  }
};

/**
 * 获取属性所占字节数(返回的bytes不能为0)
 * @param config 配置
 * @param res 当前同级数据节点
 * @returns 属性所占字节数
 */
export const getBytes = (config: DpMapItem, res: any): number => {
  const { bytes = 1 } = config;
  let temp = bytes;
  if (Array.isArray(bytes) || typeof bytes === 'string') {
    temp = get(res, bytes, 1);
  }
  return (temp as number) || 1;
};
